module.exports = __webpack_public_path__ + "static/media/naver_cafe.5b69177c.png";